<template>
	<b-jumbotron
		fluid
		bg-variant="light"
		text-variant="dark"
		class="rounded pt-3"
		border-variant="light"
		header-level="4"
		lead-tag="small"
		v-if="Object.keys(apTemplate).length !== 0"
	>
		<!-- nothing to show, there is no regions -->
		<b-alert variant="warning" :show="apTemplate.regions.length == 0" class="text-center mt-5">
			<span>
				<font-awesome-icon
					:icon="['fas', 'exclamation']"
					title="click to add new Region to the Template"
					fixed-width
				/>&nbsp;This template is empty, no regions - no questions
			</span>
		</b-alert>

		<!-- loop region-->
		<b-card
			class="mt-2 mb-2"
			:title="region.title + '-' + region.position"
			:sub-title="region.description"
			v-for="(region, i) in apTemplate.regions"
			:key="'region' + i"
		>
			<!-- ther is no questions qithin region-->
			<b-alert
				:show="groupQuestionsByRegion[region.id] == 0"
				variant="warning"
				class="mt-5 text-center"
			>
				<span>
					<font-awesome-icon
						:icon="['fas', 'exclamation']"
						title="click to add new Region to the Template"
						fixed-width
					/>&nbsp;There is no questions within this region.
				</span>
			</b-alert>

			<!-- loop questions -->
			<b-form>
				<fieldset disabled>
					<b-list-group class="my-3" flush>
						<QuestionAndAnswer
							class="text-body"
							:question="question"
							:key="'question-' + question.id + '-' + region.id + '-' + i"
							v-for="(question, i) in groupQuestionsByRegion[region.id]"
						></QuestionAndAnswer>
					</b-list-group>
				</fieldset>
			</b-form>
		</b-card>
	</b-jumbotron>
</template>

<script>
	import { groupBy, sortBy } from "lodash";
	import QuestionAndAnswer from "@/components/ap/QuestionAndAnswer.vue";

	export default {
		name: "apTemplateBodyShow_component",

		components: { QuestionAndAnswer },

		// props
		props: {
			apTemplate: {
				type: Object,
				default: function() {
					return {};
				}
			}
		},

		computed: {
			// group questions by region
			groupQuestionsByRegion() {
				// group
				let grouped = groupBy(this.apTemplate.questions, "pivot.region_id");

				// sort by position field (db)
				for (var group in grouped) {
					grouped[group] = sortBy(grouped[group], "pivot.position");
				}

				return grouped;
			}
		}
	};
</script>
<style>
	tr.b-table-details:hover {
		background-color: initial !important;
	}
</style>
